import { ReactNode } from "react";
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/outline";

interface CollapsibleSectionProps {
  title: string;
  statusLabel?: ReactNode;
  tag?: ReactNode;
  isOpen: boolean;
  onToggle: () => void;
  children: ReactNode;
  hidden?: boolean;
}

export default function CollapsibleSection({ title, statusLabel, tag, isOpen, onToggle, children, hidden }: CollapsibleSectionProps) {
  if (hidden) return null;

  return (
    <div className="collapsible-section border-b border-gray-200">
      {/* Status label above header */}
      {statusLabel && (
        <div className="pt-4 text-xs font-semibold text-blue leading-none">
          {statusLabel}
        </div>
      )}

      {/* Clickable header row */}
      <button
        type="button"
        className={`flex w-full items-center justify-between ${statusLabel ? "pt-1 pb-5" : "py-5"} text-left`}
        onClick={onToggle}
      >
        <span className={`font-gilroy font-semibold text-base ${isOpen ? "text-black" : "text-gray-400 hover:text-gray-500"}`}>
          {title}
        </span>

        <div className="flex items-center gap-2">
          {tag}
          {isOpen
            ? <ChevronUpIcon className="w-4 h-4 text-gray-400 flex-shrink-0" />
            : <ChevronDownIcon className="w-4 h-4 text-gray-400 flex-shrink-0" />
          }
        </div>
      </button>

      {/* Collapsible body */}
      {isOpen && (
        <div className="pb-8">
          {children}
        </div>
      )}
    </div>
  );
}
